// Reducer for uMap actions

import * as ActionTypes from '../constants/action_types'
import { DefaultState } from './DefaultState'
import * as ReducerUtils from './utils'

import { DefaultFilters } from './topics_reducer'

export const DefaultUMapTopicPlanState = {
  ...DefaultState
}

export const DefaultUMapTopicPlanFilteredState = {
  currentPage: 1,
  endOfResult: false
}

export const DefaultUMapTopicPlanTopLevelState = {
  currentFilters: DefaultFilters
}
const uMapTopicPlan = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultUMapTopicPlanState,
  actionRequest: ActionTypes.REQUEST_UMAP_TOPIC_PLAN,
  actionFailure: ActionTypes.REQUEST_UMAP_TOPIC_PLAN_FAILURE,
  actionReceive: ActionTypes.RECEIVE_UMAP_TOPIC_PLAN,
  actionInvalidate: ActionTypes.INVALIDATE_UMAP_TOPIC_PLAN
})

export const DefaultUMapState = {
  selectedTopic: null,
  byId: {}
}

export const genreDemoSummaryDetails = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultState,
  actionRequest: ActionTypes.REQUEST_DISCOVER_GENRE_DEMO,
  actionFailure: ActionTypes.REQUEST_DISCOVER_GENRE_DEMO_FAILURE,
  actionReceive: ActionTypes.RECEIVE_DISCOVER_GENRE_DEMO,
  actionInvalidate: ActionTypes.INVALIDATE_DISCOVER_GENRE_DEMO
})

export const uMapPlanByIdFilterPage = (state, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_UMAP_TOPIC_PLAN:
    case ActionTypes.RECEIVE_UMAP_TOPIC_PLAN:
    case ActionTypes.REQUEST_UMAP_TOPIC_PLAN_FAILURE:
    case ActionTypes.INVALIDATE_UMAP_TOPIC_PLAN:
      return uMapTopicPlan(state, action)
    default:
      return state
  }
}

export const uMapPlanByIdFilter = (state = DefaultUMapTopicPlanFilteredState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_UMAP_TOPIC_PLAN:
    case ActionTypes.RECEIVE_UMAP_TOPIC_PLAN:
    case ActionTypes.REQUEST_UMAP_TOPIC_PLAN_FAILURE:
    case ActionTypes.INVALIDATE_UMAP_TOPIC_PLAN:
      if (action.page) {
        // Compute endOfResult
        let endOfResult = state.endOfResult
        if (action.response && action.response.recommendations) {
          endOfResult = action.response.recommendations.length === 0
        }
        return {
          ...state,
          currentPage: action.page,
          endOfResult,
          [action.page]: uMapPlanByIdFilterPage(state[action.page], action)
        }
      } else {
        console.warn('Topic Plan Page action fired without a page:', action)
        return state
      }
    default:
      return state
  }
}

export const uMapPlanById = (state = DefaultUMapTopicPlanTopLevelState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_UMAP_TOPIC_PLAN:
    case ActionTypes.RECEIVE_UMAP_TOPIC_PLAN:
    case ActionTypes.REQUEST_UMAP_TOPIC_PLAN_FAILURE:
    case ActionTypes.INVALIDATE_UMAP_TOPIC_PLAN:
      const filterKey = action.filters || DefaultFilters
      return {
        ...state,
        [filterKey]: uMapPlanByIdFilter(state[filterKey], action)
      }
    default:
      return state
  }
}


export const uMapById = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_UMAP_TOPIC_PLAN:
    case ActionTypes.RECEIVE_UMAP_TOPIC_PLAN:
    case ActionTypes.REQUEST_UMAP_TOPIC_PLAN_FAILURE:
    case ActionTypes.INVALIDATE_UMAP_TOPIC_PLAN:
      return {
        ...state,
        uMapPlan: uMapPlanById(state.uMapPlan, action)
      }
    default:
      return state
  }
}

export const uMap = (state = DefaultUMapState, action) => {
  switch (action.type) {
    case ActionTypes.SET_UMAP_SELECTED_TOPIC:
      return {
        ...state,
        selectedTopic: action.topicId
      }
    case ActionTypes.REQUEST_DISCOVER_GENRE_DEMO:
    case ActionTypes.RECEIVE_DISCOVER_GENRE_DEMO:
    case ActionTypes.REQUEST_DISCOVER_GENRE_DEMO_FAILURE:
    case ActionTypes.INVALIDATE_DISCOVER_GENRE_DEMO:
      return {
        ...state,
        genreDemoSummary: genreDemoSummaryDetails(state.details, action)
      }
    case ActionTypes.REQUEST_UMAP_TOPIC_PLAN:
    case ActionTypes.RECEIVE_UMAP_TOPIC_PLAN:
    case ActionTypes.REQUEST_UMAP_TOPIC_PLAN_FAILURE:
    case ActionTypes.INVALIDATE_UMAP_TOPIC_PLAN:
      if (action.topicId) {
        return {
          ...state,
          byId: {
            ...state.byId,
            [action.topicId]: uMapById(state.byId[action.topicId], action)
          }
        }
      } else {
        console.warn('Topic plan action fired without a topic id:', action)
        return state
      }
    default:
      return state
    }
}